import { css } from 'lit';

var css_248z = css`:host{--alert-link-anchor-color:#2a3343}.alert-link{cursor:pointer}.alert-link,.alert-link:hover{color:var(--alert-link-anchor-color)}`;

export { css_248z as default };
//# sourceMappingURL=sgds-alert-link2.js.map
